import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { RangeField } from '../../../store/models/field-models';
import { extractFieldErrorMessages } from '../utils';
import { ValidationRuleType } from '../../../store/models/validator-models';

@Component({
    selector: 'app-range-field',
    templateUrl: './range-field.component.html',
    styleUrls: ['./range-field.component.scss'],
})
export class RangeFieldComponent {
    @Input() field: RangeField;
    @Input() control: FormControl;
    @Input() fieldId: string;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    get isRequired(): boolean {
        return this.field?.validators?.some((v) => v.type === ValidationRuleType.Required) || false;
    }

    get hasError(): boolean {
        return this.control?.invalid && (this.control?.touched || this.control?.dirty);
    }

    rangeChange(value: number): void {
        if (this.field.events?.onChange) {
            this.field.events.onChange(value).forEach((action) => this.store.dispatch(action));
        }
    }

    getRangeDisplayText(value: number): string {
        if (this.field?.displayFormatter) {
            return this.field.displayFormatter(value);
        }

        if (this.field?.rangeTextMap && this.field.rangeTextMap[value]) {
            return this.field.rangeTextMap[value];
        }

        return value?.toString() || '';
    }

    get errorMessages(): string[] {
        return extractFieldErrorMessages(this.control, this.field, this.translate);
    }
}
